<script lang="ts">
  import { fmtInt, fmtPct } from '../lib/format';
  import type { FunnelSnapshot } from '../lib/dashboards-api';

  let { funnel }: { funnel: FunnelSnapshot } = $props();
</script>

<div class="rounded-xl border border-[var(--color-border-3)] bg-white p-3.5">
  <div class="flex items-center justify-between mb-2.5">
    <div>
      <div class="text-[12.5px] font-bold">{funnel.name}</div>
      <div class="text-[10px] text-[var(--color-text-muted)] mt-0.5">{funnel.stages.length} стадій · 7д</div>
    </div>
    <div class="rounded-lg bg-[var(--color-pu-light)] px-2 py-0.5 text-[11px] font-bold text-[var(--color-pu-3)]">
      {fmtPct(funnel.conversionPct)}
    </div>
  </div>
  <div class="flex flex-col gap-1.5 mt-1">
    {#each funnel.stages as st (st.slug)}
      <div class="flex items-center gap-2 text-[10.5px]">
        <div class="w-[110px] truncate text-[var(--color-text-muted)]">{st.name}</div>
        <div class="flex-1 h-2.5 overflow-hidden rounded bg-[var(--color-bg-2)]">
          <div
            class="h-full rounded"
            style="width: {Math.max(2, st.pctOfEntry)}%; background: linear-gradient(90deg, var(--color-pu), var(--color-pu-2));"
          ></div>
        </div>
        <div class="w-9 text-right font-bold">{fmtInt(st.count)}</div>
      </div>
    {/each}
  </div>
</div>
